import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import * as moment from "moment";
import {GenerateContractDialogComponent} from "../generate-contract-dialog/generate-contract-dialog.component";

@Component({
  selector: 'app-price-history-detail-dialog',
  templateUrl: './price-history-detail-dialog.component.html',
  styleUrls: ['./price-history-detail-dialog.component.scss']
})
export class PriceHistoryDetailDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data, private http: HttpClient, public dialog: MatDialog) {
  }

  priceDetail: any;
  pjmLoading;
  ercotLoading;
  opportunityName
  editOpportunityName

  ngOnInit(): void {
    this.priceDetail = this.data.priceDetail;
    this.opportunityName = this.data.priceDetail.opportunityName;
    this.editOpportunityName = false;

  }
format(date){
  var date1 = new Date(date);
  return date1.toString()
}
  calculatePjm() {

    const payLoad = {
      startDate: moment(this.priceDetail.startDate, 'MM/YYYY').format('YYYY-MM-DD'),
      accountNumbers: this.priceDetail.accountNumbers.split(','),
      utility: this.priceDetail.utility,
      opportunityName: this.priceDetail.opportunityName
    }
    const requestOptions: Object = {
      responseType: 'json',
    }
    let url = environment.apiUrl + "pjm-preferred-price";
    this.pjmLoading = true;
    this.http.post<any>(url, payLoad, requestOptions).subscribe(data => {

        this.priceDetail.month6 = data.month6
        this.priceDetail.month12 = data.month12
        this.priceDetail.month18 = data.month18
        this.priceDetail.month24 = data.month24
        this.priceDetail.month36 = data.month36
        this.priceDetail.month48 = data.month48
        this.priceDetail.month60 = data.month60;
        this.priceDetail.refreshDate  = moment().format('MM/DD/YYYY hh:mm:ss');
        this.pjmLoading = false;
      }
      , error => {
        this.pjmLoading = false;
      }
    )
  }

  calculateErcot() {
    const payLoad = {
      utility: this.priceDetail.utility
      , zone: this.priceDetail.zone
      , loadType: this.priceDetail.loadType
      , startDate: moment(this.priceDetail.startDate, 'MM/YYYY').format('YYYY-MM-DD')
      , kwhYear: this.priceDetail.kwhYear
    }
    const requestOptions: Object = {
      responseType: 'json',
    }
    let url = environment.apiUrl + "ercot-preferred-price";
    //url = environment.apiUrl + "test";
    this.ercotLoading = true;
    this.http.post<any>(url, payLoad, requestOptions).subscribe(data => {

        this.priceDetail.month6 = data.month6
        this.priceDetail.month12 = data.month12
        this.priceDetail.month18 = data.month18
        this.priceDetail.month24 = data.month24
        this.priceDetail.month36 = data.month36
        this.priceDetail.month48 = data.month48
        this.priceDetail.month60 = data.month60
        this.priceDetail.sweetPrice = data.sweetPrice
        this.priceDetail.sweetTerm = data.sweetTerm
        this.priceDetail.sweetEndDate = data.sweetEndDate
        this.priceDetail.refreshDate = moment().format('MM/DD/YYYY hh:mm:ss');
        this.ercotLoading = false;
      }
      , error => {
        this.ercotLoading = false;
      }
    )
  }

  updateOpportunityName() {
    const payLoad = {
      id: this.priceDetail.id,
      opportunityName: this.opportunityName
    }
    const requestOptions: Object = {
      responseType: 'json',
    }
    const oldName = this.priceDetail.opportunityName
    this.priceDetail.opportunityName = this.opportunityName
    let url = environment.apiUrl + "update-opportunity-name";
    this.editOpportunityName = false;
    this.http.post<any>(url, payLoad, requestOptions).subscribe(data => {

      }
      , error => {

        this.priceDetail.opportunityName = oldName;
      }
    )
  }

  openContractGenDialog() {


    let utility = this.priceDetail.utility;
    let accountList = [];
    let priceDetail = this.priceDetail;
    let contractType ;

    if (this.priceDetail.market == 'PJM') {
      if (utility === 'ComEd') {
        contractType= "IL";
      } else {
        contractType = "PA";
      }
      accountList = priceDetail.accountNumbers.split(',')

    }else{
      contractType = "TX";
    }


    const dialogRef = this.dialog.open(GenerateContractDialogComponent
      , {
        data: {
          market:  this.priceDetail.market
          , contractType: contractType
          , accountList: accountList
          , priceDetail: priceDetail
          , utility: utility
          , startDate: moment(this.priceDetail.startDate, 'MM/YYYY').format('YYYY-MM-DD'),
        }
        , panelClass: 'contract-generator-dialog'
      }
    );
    dialogRef.afterClosed();


    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  formatPjmPrice(value) {
    let result = value;
    if(!isNaN(value)){
      result = '$'+value
    }

    return result
  }
  formatErcotPrice(value) {
    let result = value;
    if(!isNaN(value)){
      result =  value+' ¢'
    }

    return result
  }
}
